import React from 'react';
import { Card } from '../../../components/base/Card';

export const BenefitsSection: React.FC = () => {
  return (
    <section id="beneficios" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-primary-800 mb-6">
            Beneficios
          </h2>
          <div className="w-24 h-1 bg-primary-600 mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ventajas para todos los participantes del ecosistema BiviLinks
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12">
          {/* Para Referidores */}
          <Card className="p-8 hover:shadow-2xl transition-all duration-300 border-t-4 border-primary-600">
            <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-user-star-line text-3xl text-primary-600"></i>
            </div>
            <h3 className="text-2xl font-bold text-primary-800 mb-6">Para Referidores</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <i className="ri-check-line text-xl text-primary-600 mr-3 mt-1"></i>
                <span className="text-gray-700">Ganas dinero sin vender ni invertir.</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-xl text-primary-600 mr-3 mt-1"></i>
                <span className="text-gray-700">Obtienes ingresos pasivos por tus contactos.</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-xl text-primary-600 mr-3 mt-1"></i>
                <span className="text-gray-700">Puedes recomendar múltiples servicios desde un solo enlace.</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-xl text-primary-600 mr-3 mt-1"></i>
                <span className="text-gray-700">Controlas tus comisiones y estadísticas desde la aplicación.</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-xl text-primary-600 mr-3 mt-1"></i>
                <span className="text-gray-700">Recibes pagos automáticos y verificados.</span>
              </li>
            </ul>
          </Card>

          {/* Para Proveedores */}
          <Card className="p-8 hover:shadow-2xl transition-all duration-300 border-t-4 border-primary-600 lg:transform lg:scale-105">
            <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-store-3-line text-3xl text-primary-600"></i>
            </div>
            <h3 className="text-2xl font-bold text-primary-800 mb-6">Para Proveedores</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <i className="ri-check-line text-xl text-primary-600 mr-3 mt-1"></i>
                <span className="text-gray-700">Aumentan su visibilidad y consiguen nuevos clientes.</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-xl text-primary-600 mr-3 mt-1"></i>
                <span className="text-gray-700">Pagan solo por resultados reales.</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-xl text-primary-600 mr-3 mt-1"></i>
                <span className="text-gray-700">Pueden participar aun sin tener app propia.</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-xl text-primary-600 mr-3 mt-1"></i>
                <span className="text-gray-700">Disponen de panel para monitorear sus campañas y comisiones pagadas.</span>
              </li>
            </ul>
          </Card>

          {/* Para Usuarios */}
          <Card className="p-8 hover:shadow-2xl transition-all duration-300 border-t-4 border-primary-600">
            <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-user-smile-line text-3xl text-primary-600"></i>
            </div>
            <h3 className="text-2xl font-bold text-primary-800 mb-6">Para Usuarios</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <i className="ri-check-line text-xl text-primary-600 mr-3 mt-1"></i>
                <span className="text-gray-700">Encuentran en un solo lugar decenas de servicios confiables.</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-xl text-primary-600 mr-3 mt-1"></i>
                <span className="text-gray-700">Pueden comparar precios, leer reseñas y contratar de inmediato.</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-xl text-primary-600 mr-3 mt-1"></i>
                <span className="text-gray-700">Acceden a descuentos y promociones exclusivas.</span>
              </li>
            </ul>
          </Card>
        </div>
      </div>
    </section>
  );
};
